// import { useEffect, useState } from 'react';
// import { useNavigate, useSearchParams } from 'react-router-dom';

// const SubscriptionSuccess = () => {
//     const [loading, setLoading] = useState(true);
//     const [sessionId, setSessionId] = useState(null);
//     const navigate = useNavigate();
//     const [searchParams] = useSearchParams();

//     useEffect(() => {
//         const session_id = searchParams.get('session_id');
//         setSessionId(session_id);

//         // Simulate loading for better UX
//         setTimeout(() => {
//             setLoading(false);
//         }, 2000);
//     }, [searchParams]);

//     const handleContinue = () => {
//         navigate('/student');
//     };

//     if (loading) {
//         return (
//             <div className="min-h-screen bg-gradient-to-br from-green-50 via-blue-50 to-purple-50 flex items-center justify-center p-4">
//                 <div className="text-center">
//                     <div className="text-8xl mb-6 animate-bounce">⏳</div>
//                     <h2 className="text-3xl font-bold text-gray-800 mb-4">Apdorojame jūsų mokėjimą...</h2>
//                     <div className="flex justify-center gap-2">
//                         <div className="w-3 h-3 bg-purple-500 rounded-full animate-pulse"></div>
//                         <div className="w-3 h-3 bg-pink-500 rounded-full animate-pulse" style={{ animationDelay: '0.2s' }}></div>
//                         <div className="w-3 h-3 bg-blue-500 rounded-full animate-pulse" style={{ animationDelay: '0.4s' }}></div>
//                     </div>
//                 </div>
//             </div>
//         );
//     }

//     return (
//         <div className="min-h-screen bg-gradient-to-br from-green-50 via-blue-50 to-purple-50 flex items-center justify-center p-4">
//             <div className="bg-white rounded-3xl shadow-2xl max-w-2xl w-full p-12">
//                 {/* Success Icon */}
//                 <div className="text-center mb-8">
//                     <div className="inline-block p-6 bg-green-100 rounded-full mb-6">
//                         <div className="text-7xl">✅</div>
//                     </div>

//                     <h1 className="text-4xl font-bold text-gray-800 mb-4">
//                         Sveikiname! 🎉
//                     </h1>

//                     <p className="text-xl text-gray-600 mb-2">
//                         Jūsų prenumerata sėkmingai aktyvuota!
//                     </p>

//                     {sessionId && (
//                         <p className="text-sm text-gray-400">
//                             Sesijos ID: {sessionId.substring(0, 20)}...
//                         </p>
//                     )}
//                 </div>

//                 {/* Benefits */}
//                 <div className="bg-gradient-to-r from-purple-50 to-pink-50 rounded-2xl p-6 mb-8">
//                     <h3 className="font-bold text-gray-800 mb-4 text-center">
//                         Dabar galite naudotis:
//                     </h3>
//                     <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
//                         <div className="flex items-center gap-2">
//                             <span className="text-green-500 text-xl">✓</span>
//                             <span className="text-gray-700">Daugiau AI užklausų</span>
//                         </div>
//                         <div className="flex items-center gap-2">
//                             <span className="text-green-500 text-xl">✓</span>
//                             <span className="text-gray-700">Personalizuoti pratimai</span>
//                         </div>
//                         <div className="flex items-center gap-2">
//                             <span className="text-green-500 text-xl">✓</span>
//                             <span className="text-gray-700">Adaptyvūs klausimai</span>
//                         </div>
//                         <div className="flex items-center gap-2">
//                             <span className="text-green-500 text-xl">✓</span>
//                             <span className="text-gray-700">Prioritetinė pagalba</span>
//                         </div>
//                     </div>
//                 </div>

//                 {/* Next Steps */}
//                 <div className="bg-blue-50 rounded-2xl p-6 mb-8">
//                     <h3 className="font-bold text-gray-800 mb-3">📧 Kas toliau?</h3>
//                     <ul className="space-y-2 text-gray-700 text-sm">
//                         <li>• Gausite patvirtinimo el. laišką</li>
//                         <li>• Jūsų sąskaita automatiškai atnaujinta</li>
//                         <li>• Galite iš karto pradėti naudotis visomis funkcijomis</li>
//                         <li>• Valdyti prenumeratą galite bet kada</li>
//                     </ul>
//                 </div>

//                 {/* CTA Buttons */}
//                 <div className="flex flex-col sm:flex-row gap-4">
//                     <button
//                         onClick={handleContinue}
//                         className="flex-1 py-4 bg-gradient-to-r from-purple-500 to-pink-500 text-white rounded-xl font-bold text-lg shadow-lg hover:shadow-xl transition transform hover:scale-105"
//                     >
//                         Pradėti mokytis! 🚀
//                     </button>

//                     <button
//                         onClick={() => navigate('/subscription')}
//                         className="flex-1 py-4 bg-gray-100 text-gray-700 rounded-xl font-bold hover:bg-gray-200 transition"
//                     >
//                         Peržiūrėti planą
//                     </button>
//                 </div>

//                 {/* Support */}
//                 <div className="mt-8 text-center text-sm text-gray-500">
//                     <p>Klausimai? Susisiekite su mumis: <a href="mailto:support@eduplatform.lt" className="text-purple-600 hover:underline">support@eduplatform.lt</a></p>
//                 </div>
//             </div>
//         </div>
//     );
// };

// export default SubscriptionSuccess;
import { useEffect } from 'react';
import { CheckCircleIcon } from '@heroicons/react/24/solid';

const SubscriptionSuccess = () => {
    // Nebenaudosime useNavigate, nes mums reikia pilno perkrovimo
    // const navigate = useNavigate();

    useEffect(() => {
        // Po 3 sekundžių nukreipiame vartotoją į jo aplinką
        // ir priverčiame puslapį persikrauti.
        const timer = setTimeout(() => {
            // window.location.href atlieka pilną puslapio perkrovimą.
            // Tai užtikrins, kad bus atsisiųsti naujausi vartotojo duomenys.
            window.location.href = '/dashboard'; // Arba /student, priklausomai nuo jūsų struktūros
        }, 3000);

        return () => clearTimeout(timer); // Išvalome timer'į
    }, []);

    const handleContinue = () => {
        // Mygtukas taip pat turi daryti pilną perkrovimą
        window.location.href = '/dashboard';
    };

    return (
        <div className="min-h-screen bg-gradient-to-br from-green-50 to-blue-50 flex items-center justify-center p-4">
            <div className="bg-white rounded-2xl shadow-xl p-8 max-w-md text-center">
                <CheckCircleIcon className="w-20 h-20 text-green-500 mx-auto mb-4" />
                <h1 className="text-3xl font-bold text-gray-800 mb-2">Mokėjimas sėkmingas!</h1>
                <p className="text-gray-600 mb-6">
                    Jūsų planas atnaujintas. Po kelių sekundžių būsite nukreipti į savo mokymosi aplinką.
                </p>
                <button
                    onClick={handleContinue}
                    className="w-full py-3 px-6 bg-purple-600 text-white font-bold rounded-lg shadow-md hover:bg-purple-700 transition"
                >
                    Pradėti mokytis
                </button>
            </div>
        </div>
    );
};

export default SubscriptionSuccess;